import React, { useEffect } from "react";

import Parametros from "../components/Parametros/Parametros";
import i18n from "../i18n/config";

const ParametrosPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("pageTitle", { ns: "parametros" })}`;
  }, []);

  return <Parametros />;
};

export default ParametrosPage;
